// Debiteras den här bokningen något alls?
//
// Bakgrund: vid 0 kr visade steg 3 ändå kortval och CTA:n "Boka & betala".
// AP:s medlemspriser ÄR 0 kr (fritt spel), så det är inte ett kantfall utan
// vardag från dag 1.
//
// L60/L53: en betal-UI-grind MÅSTE hänga på exakt det villkor som avgör att
// pengar rör sig — aldrig på det VISADE beloppet. Charge-vägen
// (src/lib/bookingConfirmation.ts) beslutar per slot:
//
//     const discountMinor      = Math.round((discountAmount ?? 0) * 100);
//     const effectivePriceMinor = Math.max(0, slotTotalMinor - discountMinor);
//     if (effectivePriceMinor / 100 === 0) → INSERT som confirmed + paid
//
// Två fällor som den här helpern finns till för att undvika:
//
//   1. ÖRE, inte kronor. Charge-koden motiverar det själv: en kr-jämförelse
//      kan dölja ett kvarvarande saldo (49 öre avrundas till 0 kr). En gate på
//      wizardens `totalPrice` hade gömt betalsektionen på en bokning som
//      debiterar.
//   2. PER SLOT. `effectivePriceMinor` räknas inuti slot-loopen. En
//      multi-court-bokning kan ha en gratis och en betald slot — betalsektionen
//      får bara döljas när INGEN slot debiterar.

export interface ChargeGateInput {
  /** Slotpriser i öre, en post per slot/bana som bokas. */
  slotTotalsMinor: readonly number[];
  /** Rabatt i kronor (wizardens state), samma enhet som charge-vägen tar emot. */
  discountAmount?: number | null;
}

/**
 * Öret som faktiskt debiteras, summerat över alla slots.
 *
 * Rabatten dras per slot och klampas till 0 där — precis som charge-vägen
 * gör — så en överskjutande rabatt på en slot aldrig kan kvitta bort en
 * annan slots avgift.
 */
export function bookingChargeMinor({ slotTotalsMinor, discountAmount }: ChargeGateInput): number {
  const discountMinor = Math.round((discountAmount ?? 0) * 100);
  return slotTotalsMinor.reduce(
    (sum, slotMinor) => sum + Math.max(0, (slotMinor ?? 0) - discountMinor),
    0,
  );
}

/**
 * True när ingen slot debiterar → dölj betalsektionen, CTA blir "Boka".
 *
 * Tom lista räknas som "inget att debitera ännu" och ger `false` — vi vill
 * hellre visa betalsektionen medan priset laddar än att blinka fram "Boka"
 * och sedan byta tillbaka.
 */
export function isZeroChargeBooking(input: ChargeGateInput): boolean {
  if (input.slotTotalsMinor.length === 0) return false;
  return bookingChargeMinor(input) === 0;
}
